import { Button, useMantineTheme } from '@mantine/core';
import moment from 'moment';
import * as React from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { extenseWeekday, groupBy, months } from '../utility/util';
import './calendar.css'

export default function Calendar({
    data = [],
    onItemClick,
    onChangePeriod,
}: {
    data: {
        datetime: string;
        content: any;
        color?: string;
    }[],
    onItemClick?: any;
    onChangePeriod: (period: [Date, Date]) => void;
}){
    const theme = useMantineTheme();
    const qtLocal = localStorage.getItem(`@dmoc/quantity-days`);

    const [boxHeight, setBoxHeight] = React.useState(60);
    const [indexDate, setIndexDate] = React.useState(0);
    const [shownDates, setShownDates] = React.useState<moment.Moment[]>([]);
    const [quantityDays, setQuantityDays] = React.useState(qtLocal ? parseInt(qtLocal) : 7);

    const [hrTop, setHrTop] = React.useState(100);

    const scrollRef = React.useRef<any>();

    React.useEffect(() => {
        if(quantityDays) localStorage.setItem(`@dmoc/quantity-days`, `${quantityDays}`);
    }, [quantityDays])

    React.useEffect(() => {
        let maximum = 0;
        groupBy(data, w => moment(w.datetime).format("YYYY-MM-DD")).forEach(g => {
            if(g[1].length > maximum) maximum = g[1].length;
        });
        setBoxHeight(maximum*30 > 60 ? maximum*30 : 60);
    }, [data])

    React.useEffect(() => {
        const ds : moment.Moment[] = [];
        while(ds.length < quantityDays){
            ds.push(moment().startOf("week").add(ds.length + indexDate, "days"));
        }
        setShownDates(ds);
        onChangePeriod([
            moment().startOf("week").add(indexDate, "days").toDate(),
            moment().endOf("week").add(indexDate, "days").toDate(),
        ])
    }, [quantityDays, indexDate]);

    React.useEffect(() => {
        const interval = setInterval(() => {
            const top = (moment().hour() * boxHeight) + ((moment().minutes()/60)*boxHeight);
            setHrTop(top);
        }, 800);
        const top = (moment().hour() * boxHeight) + ((moment().minutes()/60)*boxHeight);
        setTimeout(() => {
            document.getElementsByClassName("weekdays")[0].scrollTo({top: top-120, behavior: 'smooth'});
        }, 800)
        return () => { clearInterval(interval); }
    }, [boxHeight]);

    return <div className={`dmoc-calendar`}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 10}}>
            <Button variant='outline' onClick={() => setIndexDate(id => id-7)}><FaArrowLeft /></Button>
            <div style={{flex: 1}}>

            </div>
            <Button variant='outline' onClick={() => setIndexDate(id => id+7)}><FaArrowRight /></Button>
        </div>
        <div className='months-years'>
            {shownDates.map((date, index) => (
                (index === 0 || moment(date).date() === moment(date).startOf("month").date()) && <div
                    className="item"
                    style={{
                        flex: (
                            (moment(date).endOf("month").date() - moment(date).date()) < 7
                            ? moment(date).endOf("month").date() - moment(date).date() + 1
                            : (moment(date).date() === moment(date).startOf("month").date() && index > 0)
                                ? 7-index
                                : 7
                        ),
                        backgroundColor: ['#08acc3', '#147885'][moment(date).month()%2]
                    }}
                >{months[moment(date).month()]} / {moment(date).year()}</div>
            ))}
        </div>
        <div className='weekdays-titles'>
            {shownDates.map((date) => <div className='title' style={{
                backgroundColor: moment().format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD")
                    ? '#08acc3CC'
                    : ['#08acc3EE', '#147885EE'][moment(date).month()%2]
            }}>
                {extenseWeekday(moment(date).weekday()).slice(0,3)}.
                <br/>
                {moment(date).format("DD")}
            </div>)}
        </div>
        <div className='weekdays' ref={scrollRef}>
            <hr className='now' style={{top: hrTop}} />
            {shownDates.map(date => <Weekday
                onItemClick={onItemClick}
                date={date}
                boxHeight={boxHeight}
                data={data} />)}
        </div>
    </div>
}

const Weekday = ({date, data, boxHeight, onItemClick}) => {
    return <div className='weekday'>
        <div className='body'>
            {[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23].map(hour => 
                <Hour
                    onItemClick={onItemClick}
                    data={data}
                    hour={hour}
                    date={date}
                    boxHeight={boxHeight}
                />
            )}
        </div>
    </div>
}

const Hour = ({hour, date, data, boxHeight, onItemClick}) => {
    const inTimeItems = data.filter(item => 
        moment(item.datetime).format("YYYY-MM-DD HH") === `${moment(date).format("YYYY-MM-DD")} ${`0${hour}`.slice(-2)}`
    );

    return <div className='hour' style={{height: boxHeight}}>
        <div className='time'>{`0${hour}`.slice(-2)}:00</div>
        <ul className='content'>
            {inTimeItems.map((item) => <li 
                style={{ backgroundColor: item.color }}
                onClick={() => onItemClick(item)}
            >{item.content}</li>)}
        </ul>
    </div>
}